import classNames from 'classnames'
import * as React from 'react'

import Link from '../../../common/Link/Link'
import BuildPagerWarning from '../../../common/Pager/BuildPager/BuildPagerWarning.container'
import Permalinks from '../../../common/Permalinks/Permalinks'

import type {Props} from './BuildTypeOverviewFooter.types'

import styles from './BuildTypeOverviewFooter.css'

class BuildTypeOverviewFooter extends React.PureComponent<Props> {
  getEntireHistoryLink(): string {
    const params = new URLSearchParams(document.location.search)
    params.set('tab', 'buildTypeHistoryList')
    return `${document.location.pathname}?${params.toString()}`
  }

  getText(): React.ReactNode {
    const {buildCount, maxBuildCount} = this.props

    if (buildCount === 1) {
      return '1 build found'
    }

    if (buildCount < maxBuildCount) {
      return `${buildCount} builds found`
    }

    return (
      <React.Fragment>
        {`Showing ${maxBuildCount} builds, see `}
        <Link href={this.getEntireHistoryLink()}>{'entire history'}</Link>
      </React.Fragment>
    )
  }

  render(): React.ReactNode {
    const {
      buildCount,
      buildsReady,
      branch,
      buildTypeId,
      className,
      lookupLimitWarning,
      permalinksQuery,
    } = this.props
    const classes = classNames(styles.buildTypeOverviewFooter, className)
    return (
      <div className={classes}>
        {buildCount > 0 && buildsReady && (
          <React.Fragment>
            {lookupLimitWarning ? (
              <BuildPagerWarning isShow className={styles.warning} />
            ) : (
              <span>{this.getText()}</span>
            )}
            {permalinksQuery && (
              <Permalinks buildTypeId={buildTypeId} branch={branch} queryRef={permalinksQuery} />
            )}
          </React.Fragment>
        )}
      </div>
    )
  }
}

export default BuildTypeOverviewFooter
